import tripodImage from '../images/services__tripod.jpg'
import lightImage from '../images/services__light.jpg'
import backgroundImage from '../images/services__background.jpg'

export const extraServices = [
  {
    id: "light",
    title: "Видеосвет Godox sl200ii",
    price: 400,
    unit: "₽/час",
    image: lightImage,
    description: "Светодиодный холодный постоянный источник света, чтобы дать вам еще больше возможностей сценариев освещения.",
   full_description: `
        <p>Универсальный штатив, который послужит надёжным дополнением к вашей камере,
        обеспечит удобство съёмки и более качественные фотографии или видео.</p>
        
        <p>Стандартно в стоимость аренды входят: 2 импульсных, 1 постоянный источник
        и различные насадки к ним. Вы можете арендовать дополнительные источники света.</p>
    `
  },
  {
    id: "tripod",
    title: "Штатив для камеры",
    price: 100,
    unit: "₽/час",
    image: tripodImage,
    description: "Универсальный штатив, который послужит надежным дополнением к вашей камере, обеспечит удобство съёмки и более качественные фотографии или видео.",
    full_description: `
      <p>Универсальный штатив, который послужит надёжным дополнением к вашей камере,
      обеспечит удобство съёмки и более качественные фотографии или видео.</p>
     
      <p>Стандартно в стоимость аренды входят: 2 импульсных, 1 постоянный источник
      и различные насадки к ним. Вы можете арендовать дополнительные источники света.</p>
    `},
  {
    id: "background",
    title: "Шелковый, жемчужный фон",
    price: 600,
    unit: "₽ установка",
    image: backgroundImage,
    description: "Для самых изысканных и утончённых фото. Добавьте различные детали, мебель и стильную, уникальную локацию готова.",
    full_description: `
      <p>Универсальный штатив, который послужит надёжным дополнением к вашей камере,
      обеспечит удобство съёмки и более качественные фотографии или видео.</p>
      
      <p>Стандартно в стоимость аренды входят: 2 импульсных, 1 постоянный источник
      и различные насадки к ним. Вы можете арендовать дополнительные источники света.</p>
    `
  }
];
